import { contactInfo } from '@/mocks/homeMocks';

export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2 scroll-mt-20 text-center">
            {contactInfo.title}
          </h2>
          <p className="text-sm text-foreground-600 mb-8 max-w-2xl mx-auto text-center leading-relaxed">
            {contactInfo.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-10">
            <a
              href={`mailto:${contactInfo.email}`}
              className="flex items-center gap-3 px-6 py-4 bg-background-50 rounded-lg border border-background-200/70 cursor-pointer hover:border-primary-300 transition-colors"
            >
              <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center">
                <i className="ri-mail-line text-lg text-primary-500"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">电子邮箱</p>
                <p className="text-sm text-foreground-950">{contactInfo.email}</p>
              </div>
            </a>
            <div className="flex items-center gap-3 px-6 py-4 bg-background-50 rounded-lg border border-background-200/70">
              <div className="w-10 h-10 bg-accent-100 rounded-full flex items-center justify-center">
                <i className="ri-wechat-line text-lg text-accent-500"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">微信公众号</p>
                <p className="text-sm text-foreground-950">{contactInfo.wechat}</p>
              </div>
            </div>
            <a
              href="#contact"
              className="flex items-center gap-3 px-6 py-4 bg-background-50 rounded-lg border border-background-200/70 cursor-pointer hover:border-accent-300 transition-colors"
            >
              <div className="w-10 h-10 bg-secondary-100 rounded-full flex items-center justify-center">
                <i className="ri-weibo-line text-lg text-secondary-600"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">新浪微博</p>
                <p className="text-sm text-foreground-950">{contactInfo.weibo}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}